/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ signInLink: NonNullable<unknown> }} Authstartcantcontinuebody4Inputs */

const en_authstartcantcontinuebody4 = /** @type {(inputs: Authstartcantcontinuebody4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your diagnostic results didn't make the trip. Please ${i?.signInLink} directly, or restart the diagnostic.`)
};

const pt_authstartcantcontinuebody4 = /** @type {(inputs: Authstartcantcontinuebody4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O resultado do diagnóstico não chegou. Por favor ${i?.signInLink} diretamente, ou refaça o diagnóstico.`)
};

/**
* | output |
* | --- |
* | "Your diagnostic results didn't make the trip. Please {signInLink} directly, or restart the diagnostic." |
*
* @param {Authstartcantcontinuebody4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartcantcontinuebody4 = /** @type {((inputs: Authstartcantcontinuebody4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartcantcontinuebody4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartcantcontinuebody4(inputs)
	return pt_authstartcantcontinuebody4(inputs)
});
export { authstartcantcontinuebody4 as "authStartCantContinueBody" }